import { useState, useCallback, useMemo, useRef } from 'react';
import type { PropDefinition } from '../showcases/types';

export function useShowcase(propsDefinition: PropDefinition[]) {
  const initialProps = useMemo(() => {
    const defaults: Record<string, unknown> = {};
    propsDefinition.forEach((prop) => {
      defaults[prop.name] = prop.defaultValue;
    });
    return defaults;
  }, [propsDefinition]);

  const [playgroundProps, setPlaygroundProps] =
    useState<Record<string, unknown>>(initialProps);

  // Reset props synchronously during render when propsDefinition changes.
  // This prevents a render where the showcase component receives stale props
  // from the previous component, which can cause crashes.
  const prevInitialProps = useRef(initialProps);
  if (initialProps !== prevInitialProps.current) {
    prevInitialProps.current = initialProps;
    setPlaygroundProps(initialProps);
  }

  const resetProps = useCallback(() => {
    setPlaygroundProps(initialProps);
  }, [initialProps]);

  return {
    playgroundProps,
    setPlaygroundProps,
    resetProps,
  };
}
